// Yanlış Pozitif Azaltma sonuç ekranı hesapları (saf fonksiyonlar).
// Pozitif sınıf = "Gerçek Tespit"; model "incelensin" dediğinde skor >= eşik.

export const CELL = {
  TP: 'TP',
  FP: 'FP',
  TN: 'TN',
  FN: 'FN',
};

export function cellOf(actual, predicted) {
  if (actual && predicted) {
    return CELL.TP;
  }
  if (!actual && predicted) {
    return CELL.FP;
  }
  if (!actual && !predicted) {
    return CELL.TN;
  }
  return CELL.FN;
}

// Tarama 0.01 adımlıdır; eşiğe en yakın satır döner.
export function nearestSweepRow(sweep, threshold) {
  if (!sweep || !sweep.length) {
    return null;
  }
  return sweep.reduce((best, row) =>
    Math.abs(row.threshold - threshold) < Math.abs(best.threshold - threshold) ? row : best
  );
}

export function countsFromRow(row) {
  if (!row) {
    return { tp: 0, fp: 0, tn: 0, fn: 0 };
  }
  return {
    tp: Number(row.truePositive) || 0,
    fp: Number(row.falsePositive) || 0,
    tn: Number(row.trueNegative) || 0,
    fn: Number(row.falseNegative) || 0,
  };
}

function ratio(numerator, denominator) {
  return denominator > 0 ? numerator / denominator : 0;
}

// İş diliyle göstergeler: modelin "kapatılsın" dediği alarmlar (TN + FN) analist iş yükünden düşer;
// bunların içindeki gerçek alarmlar (FN) kaçırılma riskidir.
export function computeKpis(counts) {
  const tp = counts.tp;
  const fp = counts.fp;
  const tn = counts.tn;
  const fn = counts.fn;
  const total = tp + fp + tn + fn;
  const closed = tn + fn;
  return {
    total,
    closed,
    reviewed: tp + fp,
    realCount: tp + fn,
    falsePositiveCount: tn + fp,
    fpReduction: ratio(tn, tn + fp),
    recall: ratio(tp, tp + fn),
    missed: fn,
    missedRate: ratio(fn, tp + fn),
    workloadReduction: ratio(closed, total),
    precision: ratio(tp, tp + fp),
    realInClosed: ratio(fn, closed),
    accuracy: ratio(tp + tn, total),
  };
}

export function formatPercent(value, digits = 1) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '—';
  }
  return `${(Number(value) * 100).toFixed(digits)}%`;
}

// Ağaç modellerinde önerilen eşik 0.01'in altına düşebilir; küçük eşikler 4 haneyle gösterilir.
export function formatThreshold(value) {
  const number = Number(value) || 0;
  return number < 0.01 ? number.toFixed(4) : number.toFixed(2);
}

export function formatCount(value) {
  if (value === null || value === undefined) {
    return '—';
  }
  return Number(value).toLocaleString('tr-TR');
}

// Parametresi kayıt sayısı olan uyarılar; sayı binlik ayraçla gösterilir.
const COUNT_WARNING_CODES = ['rowsSampled', 'rowsTruncated'];

// Backend uyarı kodu "kod" ya da "kod|parametre" biçimindedir.
export function parseWarning(warning) {
  const separator = warning.indexOf('|');
  if (separator < 0) {
    return { code: warning, param: '' };
  }
  const code = warning.substring(0, separator);
  const param = warning.substring(separator + 1);
  return { code, param: COUNT_WARNING_CODES.includes(code) ? formatCount(param) : param };
}

// Sabit + aday kombinasyon sayısı: adayların boş olmayan alt kümeleri (+ sabitler varsa yalnız sabitler satırı).
export function combinationCount(baseCount, candidateCount) {
  if (candidateCount <= 0) {
    return 0;
  }
  return Math.pow(2, candidateCount) - 1 + (baseCount > 0 ? 1 : 0);
}

// Backend hata yanıtı (ErrorResponseModel) HTTP 200 ile döner. errorMessage sunucu ayarına göre düz metin ya da
// {"ErrorMessage","StackTrace",...} JSON zarfıdır (ErrorHandlingMiddleware); kullanıcıya yalnız ErrorMessage gösterilir.
export function serverErrorMessage(error) {
  if (!error) {
    return '';
  }
  const raw = error.errorMessage || error.message || '';
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed.ErrorMessage === 'string' ? parsed.ErrorMessage : raw;
  } catch (parseError) {
    return raw;
  }
}

// Deney ilerleme mesajı JSON'dur: { completed, total, etaSeconds }.
export function parseProgressMessage(message) {
  if (!message) {
    return null;
  }
  try {
    return JSON.parse(message);
  } catch (error) {
    console.error('parseProgressMessage', error);
    return null;
  }
}
